import styled from 'styled-components';

export const SectionBright = styled.section`
  background: #1A5AFF;
`;
